export default __webpack_public_path__ + "static/pool_pump-cf881c12c5dc2fd39b09e5ddbf58f512.jpg";